var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 10.25H10.25V14C10.25 14.4125 9.9125 14.75 9.5 14.75C9.0875 14.75 8.75 14.4125 8.75 14V10.25H5C4.5875 10.25 4.25 9.9125 4.25 9.5C4.25 9.0875 4.5875 8.75 5 8.75H8.75V5C8.75 4.5875 9.0875 4.25 9.5 4.25C9.9125 4.25 10.25 4.5875 10.25 5V8.75H14C14.4125 8.75 14.75 9.0875 14.75 9.5C14.75 9.9125 14.4125 10.25 14 10.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/AddIcon.8864c540b387c904a101132173d6ddac.svg";
export { ForwardRef as ReactComponent };